<div class="modal-content modal-milvus" (click)="handleClick($event)">
    <ngx-spinner></ngx-spinner>
    <div class="modal-header-milvus align-items-center dark-back">
        <div class="col-6 header-col" style="margin-top: -10px; margin-left: -6px;">
            <span class="modal-title" id="modal-title-default">{{'MENSAGENS' | translate}}</span>
        </div>
        <div class="col-6 header-col" style="margin-top: -10px;">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
                <i class="mdi mdi-close"></i>
            </button>
        </div>
    </div>

    <div *ngIf="!apenas_historico; else leituraHistorico" class="modal-body divider-top px-0" style="overflow: hidden; padding: 0 !important;">
        <div class="row">
            <div class="col-4 dark-back divider-right" style="padding: 10px">
                <div class="row">
                    <div class="col-md-4 ml-4">
                        <!-- Avatar -->
                        <span class="avatar avatar-md rounded-circle mt-3">
                            <img *ngIf="tokenData?.foto !== null" alt="Image placeholder" [src]="tokenData?.foto" />
                            <span *ngIf="tokenData?.foto === null"
                                style="font-weight: bold; text-transform: uppercase;">{{splitName(tokenData.nome)}}</span>
                        </span>
                    </div>
                    <div class="col d-flex justify-content-end py-4">
                        <div container=".modal" [ngbTooltip]="translate.instant('AGUARDANDO')" placement="bottom">
                            <button type="button" class="btn  btn-bg-lightness btn-icon-only rounded-circle"
                                [ngClass]="{'choosen-button-aguardando' : statusSelecionado === 1}"
                                style=" width: 35px; height: 35px; margin-right: 14px;" (click)="changeStatus(1)"><span
                                    class="btn-inner--icon"><i style="color:#F96342"
                                        class="fas fa-hourglass-start"></i></span> <span class="counter"
                                    style="background:#F96342 ">{{ contadores && contadores.ag_atendimento ?
                                    (contadores.ag_atendimento > 99 ? '99+' : contadores.ag_atendimento) :
                                    0}}</span></button>
                        </div>
                        <div container=".modal" [ngbTooltip]="('EM_ATENDIMENTO' | translate)" placement="bottom">
                            <button type="button" class="btn  btn-bg-lightness btn-icon-only rounded-circle"
                                [ngClass]="{'choosen-button-atendimento' : statusSelecionado === 2}"
                                style=" width: 35px; height: 35px; margin-right: 14px;" (click)="changeStatus(2)"><span
                                    class="btn-inner--icon"><i style="color:#268F62"
                                        class="fas fa-headset"></i></span><span class="counter"
                                    style="background:#268F62 ">{{contadores && contadores.atendendo ?
                                    (contadores.atendendo > 99 ? '99+' : contadores.atendendo) : 0}}</span></button>
                        </div>
                        <div container=".modal" [ngbTooltip]="('FINALIZADO' | translate)" placement="bottom">
                            <button type="button" class="btn  btn-bg-lightness btn-icon-only rounded-circle"
                                [ngClass]="{'choosen-button-finalizado' : statusSelecionado === 3}"
                                style=" width: 35px; height: 35px; margin-right: 14px;" (click)="changeStatus(3)"><span
                                    class="btn-inner--icon"><i style="color:#007A7D"
                                        class="fas fa-check"></i></span><span class="counter"
                                    style="background:#007A7D ">{{contadores && contadores.finalizado ?
                                    (contadores.finalizado > 99 ? '99+' : contadores.finalizado) : 0}}</span></button>
                        </div>
                        <!-- <div *ngIf="hasIntegracao" container=".modal" [ngbTooltip]="('CHAMAR_CONTATO_WHATS' | translate)"
                            placement="bottom">
                            <button type="button" class="btn  btn-bg-lightness btn-icon-only rounded-circle"
                                style=" width: 35px; height: 35px; margin-right: 4px;" (click)="openModalConversaZap()"><span
                                    class="btn-inner--icon"><i style="color:#53D58E" class="fas fa-plus"></i></span>
                            </button>
                        </div>
                        <div *ngIf="!hasIntegracao || !integracaoCompleta" container=".modal" [ngbTooltip]="('NAO_POSSUI_INTEGRACAO' | translate)"
                            placement="bottom">
                            <button [disabled]="true" type="button"
                                class="btn  btn-bg-lightness btn-icon-only rounded-circle"
                                style=" width: 35px; height: 35px; margin-right: 4px;"><span
                                    class="btn-inner--icon"><i style="color:#53D58E" class="fas fa-plus"></i></span>
                            </button>
                        </div> -->
                        <button type="button" class="btn btn-integration btn-icon-only rounded-circle" container=".modal" [ngbTooltip]="('VISUALIZAR_CONTATOS' | translate)"
                        placement="bottom" (click)="openModalConversaZap()"
                            style=" width: 35px; height: 35px; margin-right: 4px;">
                            <i class="fa-solid fa-address-book"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-8 dark-back">
                <!-- informacoes do chat -->
                <div class="row  line-data">
                    <div *ngIf="chatSelecionado" class="d-flex col-6 mt-2">
                        <div>
                            <img alt="Image placeholder" [src]="chatSelecionado.avatar || 'assets/img/theme/user.png'"
                                class="avatar rounded-circle mt-1 mr-3" style="max-width: 49px;" (click)="abrirInfoContato(chatSelecionado)" />
                        </div>
                        <div>
                            <div class="chat-name">
                                {{chatSelecionado.contato?.descricao ? chatSelecionado.contato?.descricao : 
                                chatSelecionado.numero_contato ? chatSelecionado.numero_contato : ''}} 
                                {{chatSelecionado.cliente && chatSelecionado.cliente.text ? '- ' + chatSelecionado.cliente.text : null }}
                            </div>
                            <div class="chat-name">
                                {{chatSelecionado.contato?.celular ?
                                (chatSelecionado.contato?.celular | mask:retornaMascaraNum(chatSelecionado.contato?.celular)) : chatSelecionado.contato?.telefone 
                                ? (chatSelecionado.contato?.telefone | mask:retornaMascaraNum(chatSelecionado.contato?.telefone)) : ''}}
                                {{chatSelecionado.contato?.email ? '- ' + chatSelecionado.contato?.email : chatSelecionado.email ?
                                '- ' + chatSelecionado.email : ''}}
                            </div>
                            <div class="chat-lastmsg" style="cursor: pointer;" *ngIf="chatSelecionado.chamado_vinculado"
                                (click)="openTicket(chatSelecionado.chamado_vinculado)">
                                <i style="margin-top: 5px;" *ngIf="chatSelecionado.chamado_vinculado"
                                    class="fas fa-ticket-alt fa-lg"></i> 
                                    {{ chatSelecionado.chamado_vinculado ? ' #'+chatSelecionado.chamado_vinculado.codigo : ''}}
                            </div>
                            <div class="chat-lastmsg">
                                {{ 'ULTIMA_INTERACAO' | translate }} {{chatSelecionado.data_mensagem}}
                            </div>
                            <div *ngIf="chatSelecionado && chatSelecionado?.transferencia_msg_title" [ngbTooltip]="chatSelecionado?.transferencia_msg_title?.length > 50 ? chatSelecionado?.transferencia_msg_title : ''" class="chat-lastmsg" style="color: #004eff;">
                                {{chatSelecionado?.transferencia_msg_title}}
                            </div>
                        </div>
                        <div class="ml-4 mt-2">
                            <button *ngIf="chatSelecionado.contato?.id" container=".modal" [ngbTooltip]="('EDITAR_CONTATO' | translate)" type="button" class="btn btn-bg-lightness btn-icon-only rounded-circle"
                                style=" width: 35px; height: 35px; margin-right: 4px; border: 1px solid #3f73e9" (click)="abrirModalContato()"><span
                                    class="btn-inner--icon"><i style="color:#3f73e9" class="fas fa-pen"></i></span>
                            </button>
                            <button *ngIf="!chatSelecionado.contato?.id && !chatSelecionado.contato_multiplos" container=".modal" [ngbTooltip]="('ADICIONAR_CONTATO' | translate)" type="button" class="btn btn-bg-lightness btn-icon-only rounded-circle"
                                style=" width: 35px; height: 35px; margin-right: 4px; border: 1px solid #53D58E" (click)="abrirModalContato()"><span
                                    class="btn-inner--icon"><i style="color:#53D58E" class="fas fa-plus"></i></span>
                            </button>
                            <button *ngIf="!chatSelecionado.contato?.id && chatSelecionado.contato_multiplos" container=".modal" [ngbTooltip]="('SELECIONAR_CRIAR_CONTATO' | translate)" type="button" class="btn btn-bg-lightness btn-icon-only rounded-circle"
                                style=" width: 35px; height: 35px; margin-right: 4px; border: 1px solid #f58b00" (click)="abrirModalContato(true)"><span
                                    class="btn-inner--icon"><i style="color:#f58b00; font-size: 17px;" class="far fa-address-book"></i></span>
                            </button>
                        </div>
                    </div>

                    <div *ngIf="chatSelecionado" class="col-6 text-right">
                        <div style="padding: 15px">
                            <button *ngIf="chatSelecionado.contato_id" type="button" (click)="openHistoricoUnificado(chatSelecionado)"
                                class="btn btn-info-light btn-sm small-circled-btn" 
                                container=".modal" [ngbTooltip]="('CONSULTAR_HISTORICO_UNIFICADO' | translate)" 
                                placement="bottom" tooltipClass="tooltip-btns-chat" style="margin-right: 15px;">
                                <i class="fa-kit fa-chat-clock"></i>
                            </button>
                            <button type="button" (click)="openHistorico(chatSelecionado)"
                                class="btn btn-light btn-sm small-circled-btn" 
                                container=".modal" [ngbTooltip]="('CONSULTAR_HISTORICO' | translate)" 
                                placement="bottom" tooltipClass="tooltip-btns-chat"
                                style="padding: 0px 1px 0px 0px;">
                                <i class="mdi mdi-history" style="font-size: 22px;"></i>
                            </button>
                            <button type="button" (click)="iniciarAtendimento(chatSelecionado)"
                                class="btn btn-success btn-sm small-circled-btn"
                                *ngIf="chatSelecionado.status_id == 1" 
                                style="margin-left: 7px;" 
                                container=".modal" ngbTooltip="{{ 'INICIAR_ATENDIMENTO' | translate}}"
                                placement="bottom" tooltipClass="tooltip-btns-chat">
                                <i class="mdi mdi-play"></i>
                            </button>
                            <ng-container *ngIf="solicitantes_habilitados.solicitante_cliente || solicitantes_habilitados.solicitante_contato">
                                <button type="button" 
                                    class="btn btn-alert btn-sm small-circled-btn"
                                    style="margin-left: 7px;"
                                    *ngIf="chatSelecionado.chamado_vinculado && chatSelecionado.status_id != 1 && checkStatusIdChamadoVinculado()"
                                    [disabled]="(chatSelecionado.status_id === 3)"
                                    (click)="encerrarCriarTicket(chatSelecionado)"
                                    container=".modal" ngbTooltip="{{ 'ENCERRAR_FINALIZAR_TICKET' | translate}}"
                                    placement="bottom" tooltipClass="tooltip-btns-chat">
                                    <svg style="width:20px;height:20px;margin-top:-3px;" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8 8 7.33 8 6.5 7.33 5 6.5 5M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8 8 7.33 8 6.5 7.33 5 6.5 5M21.41 11.58L12.41 2.58C12.04 2.21 11.53 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.53 2.21 12.04 2.59 12.42L3 12.82C3.64 12.44 4.35 12.19 5.08 12.08L4 11V4H11L20 13L13 20L11.92 18.92C11.82 19.66 11.56 20.36 11.18 21L11.59 21.41C11.96 21.79 12.47 22 13 22C13.53 22 14.04 21.79 14.41 21.41L21.41 14.41C21.79 14.04 22 13.53 22 13C22 12.47 21.79 11.96 21.41 11.58M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8 8 7.33 8 6.5 7.33 5 6.5 5M8.63 14.27L4.76 18.17L3.41 16.8L2 18.22L4.75 21L10.03 15.68L8.63 14.27" />
                                    </svg>
                                </button>
                                <button type="button" 
                                    class="btn btn-alert btn-sm small-circled-btn"
                                    *ngIf="!chatSelecionado.chamado_vinculado && chatSelecionado.status_id != 1"
                                    style="margin-left: 7px;"
                                    [disabled]="(chatSelecionado.status_id === 3)"
                                    (click)="encerrarCriarTicket(chatSelecionado)"
                                    container=".modal" ngbTooltip="{{ 'ENCERRAR_CRIAR_TICKET' | translate}}"
                                    placement="bottom" tooltipClass="tooltip-btns-chat">
                                    <svg style="width:20px;height:20px;margin-top:-3px;" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M6.5 5A1.5 1.5 0 1 0 8 6.5A1.5 1.5 0 0 0 6.5 5M6.5 5A1.5 1.5 0 1 0 8 6.5A1.5 1.5 0 0 0 6.5 5M21.41 11.58L12.41 2.58A2 2 0 0 0 11 2H4A2 2 0 0 0 2 4V11A2 2 0 0 0 2.59 12.42L3 12.82A5.62 5.62 0 0 1 5.08 12.08L4 11V4H11L20 13L13 20L11.92 18.92A5.57 5.57 0 0 1 11.18 21L11.59 21.41A2 2 0 0 0 13 22A2 2 0 0 0 14.41 21.41L21.41 14.41A2 2 0 0 0 22 13A2 2 0 0 0 21.41 11.58M6.5 5A1.5 1.5 0 1 0 8 6.5A1.5 1.5 0 0 0 6.5 5M10 19H7V22H5V19H2V17H5V14H7V17H10Z" />
                                    </svg>
                                </button>
                            </ng-container>

                            <button type="button" (click)="transferirChat(chatSelecionado)"
                                class="btn btn-info-2 btn-sm small-circled-btn"
                                style="margin-left: 7px; padding: 2px 1px;"
                                [disabled]="(chatSelecionado.status_id === 3)"
                                container=".modal" ngbTooltip="{{ 'TRANSFERIR_CHAT' | translate}}"
                                placement="bottom" tooltipClass="tooltip-btns-chat">
                                <i class="mdi mdi-message-arrow-right-outline" style="font-size: 22px;"></i>
                            </button>

                            <button type="button" (click)="conciliarTicket(chatSelecionado)"
                                class="btn btn-success-dark btn-sm small-circled-btn"
                                *ngIf="verificaVisibilidadeConciliacao(chatSelecionado) || (!chatSelecionado.is_whatsapp && !chatSelecionado.is_telegram)"
                                style="margin-left: 7px; padding: 2px 1px;"
                                container=".modal" ngbTooltip="{{ 'ASSOCIAR_TICKET' | translate}}"
                                placement="bottom" tooltipClass="tooltip-btns-chat">
                                <i class="mdi mdi-tag-multiple-outline" style="font-size: 22px;"></i>
                            </button>

                            <button type="button" (click)="associarContato(chatSelecionado)"
                                class="btn btn-purple btn-sm small-circled-btn"
                                *ngIf="!chatSelecionado.contato"
                                style="margin-left: 7px; padding: 0px 1px 0px 0px;"
                                container=".modal" ngbTooltip="{{ 'ASSOCIAR_CONTATO' | translate}}"
                                placement="bottom" tooltipClass="tooltip-btns-chat">
                                <i class="mdi mdi-account-plus" style="font-size: 22px;"></i>
                            </button>

                            <button type="button" (click)="abrirModalFinalizar(chatSelecionado)"
                                *ngIf="chatSelecionado.status_id != 1"
                                class="btn btn-danger btn-sm small-circled-btn"
                                style="margin-left: 7px;"
                                [disabled]="(chatSelecionado.status_id === 3)"
                                container=".modal" ngbTooltip="{{ 'ENCERRAR_ATENDIMENTO' | translate}}"
                                placement="bottom-right" tooltipClass="tooltip-btns-chat">
                                <i class="mdi mdi-close"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row dark-back" style="height: 100%;">
            <div class="col-4 col-holder p-0 darker-back divider-right divider-top">
                <div class="input-search-chats">
                    <i class="fas fa-search"></i>
                    <input class="form-control" [(ngModel)]="searchText" (ngModelChange)="onSearchTermChange($event)" placeholder="{{ 'BUSCAR' | translate }}" type="text" name="search" autocomplete="off" />
                </div>
                <!-- listagem -->
                <div *ngIf="!loadingChats; else loadingChatsTemp" class="chat-list" #chatList (scroll)="onScrollChatList($event)">
                    <ng-container *ngIf="listaChats.length; else semChatsNaLista">
                        <ng-container *ngFor="let chat of listaChats; let i = index">
                            <div class="chat-item card" style="border-radius: 7px;"
                                [ngStyle]="{'border-left': chat?.selecionado ? '7px solid #278F63' : '7px solid #D7D7D7'}"
                                (click)="abrirChat(chat)">
                                <div class="row">
                                    <div class="col-md-2 text-center d-flex align-items-center justify-content-center"
                                        style="border-right: 1px solid #D8D8D8;">
                                        <span *ngIf="chat?.possui_mensagens_nao_lidas">
                                            <i class="fas fa-circle"
                                                style="margin-right: 12px; color: #278F63; font-size: 9px;"></i>
                                        </span>
                                        <span *ngIf="chat?.is_telegram === true">
                                            <g class="icon-telegram">
                                                <svg width="25" height="23" viewBox="0 0 25 23" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M22.8765 0.00204882C22.5152 0.0177633 22.1837 0.121664 21.8925 0.236454C21.6234 0.342416 20.6572 0.748517 19.1187 1.39383C17.5801 2.03914 15.5415 2.89474 13.3684 3.80869C9.02233 5.63658 4.13845 7.69272 1.63595 8.74585C1.55001 8.78165 1.201 8.8885 0.815534 9.18291C0.429172 9.47801 0 10.1185 0 10.8189C0 11.3839 0.282054 11.9593 0.622638 12.2888C0.963223 12.6182 1.3084 12.7723 1.59688 12.887V12.8846C2.57204 13.2731 5.48419 14.4384 6.17755 14.7158C6.42349 15.4529 7.47931 18.6081 7.73048 19.4015H7.72804C7.90558 19.9631 8.07863 20.3291 8.31894 20.6346C8.43909 20.7873 8.58252 20.9257 8.75845 21.035C8.82595 21.0769 8.90069 21.1095 8.97576 21.14C8.98622 21.1445 8.997 21.1456 9.0075 21.1498L8.9782 21.1425C8.99997 21.1512 9.0195 21.1641 9.04169 21.1718C9.07784 21.1842 9.10289 21.1838 9.15156 21.1937C9.32284 21.2464 9.49381 21.2816 9.65212 21.2816C10.3317 21.2816 10.7484 20.9129 10.7484 20.9129L10.7753 20.8934L13.7103 18.4102L17.3045 21.7358C17.3701 21.8285 17.8844 22.5245 19.0747 22.5245C19.785 22.5245 20.3465 22.1729 20.7058 21.8042C21.0651 21.4354 21.2889 21.0581 21.3895 26467L21.3919 20.5442C21.4721 20.1315 24.9129 2.85398 24.9129 2.85398L24.9055 2.88328C25.0126 2.40528 25.0442 1.94303 24.9177 1.47196C24.7912 1.0009 24.4498 0.541181 24.0387 0.299939C23.6276 0.0586967 23.2377 -0.0136662 22.8765 0.00204882ZM22.3832 2.73922C22.2473 3.42184 19.1651 18.9064 18.9746 19.8776L13.7835 15.0748L10.2748 18.0415L11.2466 14.2422C11.2466 14.2422 17.9506 7.45611 18.3544 7.06106C18.6794 6.74477 18.7475 6.63389 18.7475 6.52388C18.7475 6.37761 18.6722 6.27238 18.4985 6.27238C18.3422 6.27238 18.13 6.42213 18.0174 6.49214C16.5877 7.38351 10.4981 10.8538 7.5034 12.5574C7.32318 12.4851 4.61745 11.3986 3.15958 10.8164C5.75275 9.72504 10.1979 7.85485 14.3378 6.11367C16.5104 5.19988 18.5485 4.34351 20.0856 3.69881C21.3831 3.15461 22.0599 2.87283 22.3832 2.73922ZM18.938 20.0559H18.9404L18.938 20.0632C18.9396 20.0551 18.9368 20.0622 18.938 20.0559Z"/>
                                                </svg> 
                                            </g>   
                                        </span>
                                        <span *ngIf="chat?.is_whatsapp === false && chat?.is_telegram === false">
                                            <i style="margin-top: 9px;"
                                                class="far fa-comment fa-lg"></i>                                        
                                        </span>
                                        <span *ngIf="chat?.is_whatsapp === true">
                                            <i style="margin-top: 9px;"
                                                class="fab fa-whatsapp fa-lg"></i>
                                        </span>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="row">
                                            <div class="col-md-2 d-flex align-items-center justify-content-center">
                                                <img alt="Image placeholder"
                                                    [src]="chat?.avatar || 'assets/img/theme/user.png'"
                                                    class="chat-avatar rounded-circle" />
                                            </div>
                                            <div class="col-md-10">
                                                <div class="chat-name">
                                                    {{chat?.contato?.descricao ? (chat?.contato?.descricao | ellipsis:24) : chat?.contato
                                                    &&
                                                    chat?.contato.email ? chat?.contato.email : chat?.contato &&
                                                    chat?.contato.telefone ? (chat?.contato.telefone | ellipsis:24) :
                                                    chat?.numero_contato ?
                                                    chat?.numero_contato : 'SEM_CONTATO_CADASTRADO' | translate }}
                                                </div>
                                                <div class="chat-lastmsg" [innerHTML]="formatLastMsg(chat?.ultima_mensagem, chat)">
                                                </div>
                                                <div *ngIf="chat && chat?.transferencia_msg_title" [ngbTooltip]="chat?.transferencia_msg_title?.length > 42 ? chat?.transferencia_msg_title : ''" class="chat-lastmsg" style="color: #004eff;">
                                                    {{chat?.transferencia_msg_title}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div *ngIf="chat?.possui_fila_atribuida" class="fila-chat" [ngClass]="geraClasseFila(chat?.fila_atendimento)">
                                            <span container=".modal" [ngbTooltip]="(chat?.fila_atendimento?.descricao?.length > 25) ? chat?.fila_atendimento?.descricao : ''" 
                                                placement="bottom">
                                                {{chat?.fila_atendimento.descricao | ellipsis:25}}
                                            </span>
                                        </div>
                                        <div class="chat-time">
                                            {{formatDateList(chat?.data_mensagem)}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="!loadingScroll; else loadingChatsScrollTemp"></ng-container>
                    </ng-container>
                </div>
                <div *ngIf="listaChats.length && totalRegistrosChats" class="d-flex align-items-center" style="position: absolute; left: 30px; bottom: 115px;">
                    <span>{{'MOSTRANDO_PAGINACAO_CHATS' | translate: {from: listaChats.length, total: totalRegistrosChats} }}</span>
                </div>
            </div>
            <div [ngClass]="allowChatGPT && closeChatGPTModal ? 'col-5' : 'col-8'"
             class="darker-back divider-top p-0" style="max-height: 100%;">
                <div id="chat-msgs">
                    <div #scrollMe id="msg-item" class="msg-item" (scroll)="onScroll($event)">
                        <div #messages class="msg" *ngFor="let msg of mensagensChat; let i = index; let last = last">
                            <div (dblclick)='reponderMensagem(msg)' [id]="'msg-'+i"
                                [ngClass]="msg.enviado_por === 'robo' || msg.enviado_por === 'tecnico' || msg.is_tranferencia ? 'text-right' : 'text-left'">
                                <div appNoDblClick container=".modal" class="msg-origem" *ngIf="(msg.enviado_por === 'robo' || msg.enviado_por === 'tecnico') && msg.formatedBody && !msg.error_code">
                                    <div *ngIf="chatSelecionado?.status_id === 2 && chatSelecionado?.is_whatsapp" class="reply-btn-left">
                                        <div class="reply-icon" style="color: var(--color-default);"><i (click)="showReply(i)" class="fa-regular fa-circle-chevron-down"></i></div>
                                        <div *ngIf="activeIndex === i" class="reply" (click)="reponderMensagem(msg)"><i class="fa-regular fa-reply"></i> Responder</div>
                                    </div>
                                    <div *ngIf="msg.resposta_enviado_por">
                                        <div (click)='scrollToMessage(msg.resposta_message_id)' id="msg.id" [ngClass]="[msg.theme === 'msg-resposta' ? 'msg-resposta' : 'msg-resposta-dark', msg.themePor === 'msg-enviado-por-cliente' ? 'msg-enviado-por-cliente' : 'msg-enviado-por-tecnico']"> 
                                            <div class="text-left">
                                                <span [ngStyle]="{'margin-top': '6px', 'color': msg.resposta_enviado_por === 'tecnico' ? 'rgb(110, 108, 222)' : 'rgb(53, 178, 124)'}">{{msg.enviado_por_resposta}}</span><br/>
                                                    <div [innerHtml]="msg.formatedBodyResposta" ></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="msg.tipo !== 'contato'" [ngbTooltip]="msg.autor ? msg.autor.nome : msg.user"
                                        [innerHtml]="msg.formatedBody"
                                        (click)="visualizarArquivo(msg, $event)"
                                        class="text-left"
                                        style="white-space: pre-line; word-break: break-word;"
                                        >
                                    </div>
                                    <div *ngIf="msg.tipo === 'contato'" [ngbTooltip]="msg.autor ? msg.autor.nome : msg.user"
                                        class="text-left"
                                        style="white-space: pre-line; word-break: break-word;"
                                        >
                                        contato
                                    </div>
                                </div>
                                <div container=".modal" class="msg-origem-error" *ngIf="(msg.enviado_por === 'robo' || msg.enviado_por === 'tecnico') && msg.formatedBody && msg.error_code > 0">
                                    <div *ngIf="msg.resposta_enviado_por">
                                        <div (click)='scrollToMessage(msg.resposta_message_id)' id="msg.id" [ngClass]="[msg.theme === 'msg-resposta' ? 'msg-resposta' : 'msg-resposta-dark', msg.themePor === 'msg-enviado-por-cliente' ? 'msg-enviado-por-cliente' : 'msg-enviado-por-tecnico']"> 
                                            <div class="text-left">
                                                <span *ngIf="msg.resposta_enviado_por === 'tecnico'" style="margin-top: 6px; color:rgb(110, 108, 222)">{{msg.enviado_por_resposta}}</span><br/>
                                                <span *ngIf="msg.resposta_enviado_por === 'cliente'" style="margin-top: 6px; color:rgb(53, 178, 124)">{{msg.enviado_por_resposta}}</span><br/>
                                                    <div [innerHtml]="msg.formatedBodyResposta" ></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div [ngbTooltip]="msg.error_msg_descricao"
                                        [innerHtml]="msg.formatedBody"
                                        (click)="visualizarArquivo(msg, $event)"
                                        class="text-left"
                                        style="white-space: pre-line; word-break: break-word;">
                                    </div>
                                </div>
                                <div container=".modal" class="msg-transferencia msg-origem" *ngIf="msg.is_tranferencia && msg.formatedBody">
                                    <div *ngIf="msg.resposta_enviado_por">
                                        <div (click)='scrollToMessage(msg.resposta_message_id)' id="msg.id" [ngClass]="[msg.theme === 'msg-resposta' ? 'msg-resposta' : 'msg-resposta-dark', msg.themePor === 'msg-enviado-por-cliente' ? 'msg-enviado-por-cliente' : 'msg-enviado-por-tecnico']"> 
                                            <div class="text-left">
                                                <span *ngIf="msg.resposta_enviado_por === 'tecnico'" style="margin-top: 6px; color:rgb(110, 108, 222)">{{msg.enviado_por_resposta}}</span><br/>
                                                <span *ngIf="msg.resposta_enviado_por === 'cliente'" style="margin-top: 6px; color:rgb(53, 178, 124)">{{msg.enviado_por_resposta}}</span><br/>
                                                    <div [innerHtml]="msg.formatedBodyResposta" ></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div [ngbTooltip]="msg.error_msg_descricao"
                                        [innerHtml]="msg.formatedBody"
                                        (click)="visualizarArquivo(msg, $event)"
                                        [class.mensagem-erro]="msg.erro_envio"
                                        [class.mensagem-origem]="!msg.erro_envio"
                                        class="text-left"
                                        style="white-space: pre-line; word-break: break-word;">
                                    </div>
                                </div>

                                <div appNoDblClick container=".modal" class="msg-destino" *ngIf="msg.enviado_por === 'cliente' && msg.formatedBody">
                                    <!-- Separação de anexos com legenda -->
                                    <ng-container *ngIf="msg.tipo === 'anexo' && msg.msg_legenda && !msg.resposta_enviado_por; else msgComum">
                                        <div [ngbTooltip]="chatSelecionado?.contato?.descricao ? chatSelecionado?.contato?.descricao : 
                                            chatSelecionado?.numero_contato ? chatSelecionado?.numero_contato : msg?.autor ? msg?.autor?.nome : msg?.user"
                                            (click)="visualizarArquivo(msg, $event)"
                                            class="text-left" style="white-space: pre-line; word-break: break-word;">
                                            <div class="msg-anexo-com-legenda" [innerHtml]="msg?.formatedBody"></div>
                                            <div class="mt-2" [innerHTML]="msg?.msg_legenda"></div>
                                            <div class="text-right">
                                                <span class="msg-time">{{msg?.data_mensagem | date:'dd/MM/YYYY HH:mm:ss'}}</span>
                                            </div>
                                        </div>
                                        <div *ngIf="chatSelecionado?.status_id === 2 && chatSelecionado?.is_whatsapp" class="reply-btn">
                                            <div class="reply-icon"><i (click)="showReply(i)" class="fa-regular fa-circle-chevron-down"></i></div>
                                            <div *ngIf="activeIndex === i" class="reply" (click)="reponderMensagem(msg)"><i class="fa-regular fa-reply"></i> Responder</div>
                                        </div>
                                    </ng-container>
                                    <ng-template #msgComum>
                                        <div *ngIf="msg?.resposta_enviado_por">
                                            <div (click)='scrollToMessage(msg.resposta_message_id)' id="msg.id" [ngClass]="[msg.theme === 'msg-resposta' ? 'msg-resposta' : 'msg-resposta-dark', msg.themePor === 'msg-enviado-por-cliente' ? 'msg-enviado-por-cliente' : 'msg-enviado-por-tecnico']"> 
                                                <div class="text-left">
                                                    <span [ngStyle]="{'margin-top': '6px', 'color': msg.resposta_enviado_por === 'tecnico' ? 'rgb(110, 108, 222)' : 'rgb(53, 178, 124)'}">{{msg?.enviado_por_resposta}}</span><br/>
                                                        <div [innerHtml]="msg?.formatedBodyResposta" ></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="msg.tipo !== 'contato'" [ngbTooltip]="chatSelecionado?.contato?.descricao ? chatSelecionado?.contato?.descricao : 
                                            chatSelecionado?.numero_contato ? chatSelecionado?.numero_contato : msg?.autor ? msg?.autor?.nome : msg?.user"
                                            [innerHtml]="msg.formatedBody"
                                            (click)="visualizarArquivo(msg, $event)"
                                            class="text-left" style="white-space: pre-line; word-break: break-word;">
                                        </div>
                                        <div *ngIf="msg.tipo === 'contato'" [ngbTooltip]="chatSelecionado?.contato?.descricao ? chatSelecionado?.contato?.descricao : 
                                            chatSelecionado?.numero_contato ? chatSelecionado?.numero_contato : msg?.autor ? msg?.autor?.nome : msg?.user"
                                            class="text-left" style="white-space: pre-line; word-break: break-word;">
                                            <div *ngFor="let contato of msg.contato; let i = index;" class="msg-contato">
                                                <div class="msg-contato-nome">
                                                    <img [src]="contato?.avatar || 'assets/img/theme/user.png'" class="msg-contato-avatar rounded-circle" /> 
                                                    {{contato?.nome_contato}}
                                                </div>
                                                <button *ngIf="!contato?.existe" (click)="salvarContato(contato)" class="msg-contato-botao">{{!contato?.botao ? 'Salvar Contato' : 'Iniciar Conversa'}}</button>
                                                <button *ngIf="contato?.existe" (click)="iniciarConversa(contato)" class="msg-contato-botao">Iniciar Conversa</button>
                                            </div>
                                            <div [innerHtml]="msg?.formatedBody"></div>
                                        </div>
                                        <div *ngIf="chatSelecionado?.status_id === 2 && chatSelecionado?.is_whatsapp" class="reply-btn">
                                            <div class="reply-icon"><i (click)="showReply(i)" class="fa-regular fa-circle-chevron-down"></i></div>
                                            <div *ngIf="activeIndex === i" class="reply" (click)="reponderMensagem(msg)"><i class="fa-regular fa-reply"></i> Responder</div>
                                        </div>
                                    </ng-template>
                                </div>
                                {{last ? scrollToBottom() : ''}}
                            </div>
                        </div>
                    </div>
                    <div class="darker-back input-box" *ngIf="chatSelecionado">
                        <div id="respostaBox" *ngIf="respostaSelecionada" class="px-3 pt-2 resposta-selecionada">
                            <div [ngClass]="[respostaSelecionada.theme === 'msg-resposta' ? 'msg-resposta' : 'msg-resposta-dark', respostaSelecionada.enviado_por === 'cliente' ? 'msg-enviado-por-cliente' : 'msg-enviado-por-tecnico']"> 
                                <div (click)="removeResposta()" class="text-right float-right mr-2 mt-2 pointer">
                                    <i class="far fa-times-circle" style="font-size:24px; cursor:pointer"></i>
                                </div>
                                <div class="text-left">
                                    <span [ngStyle]="{'margin-top': '6px', 'color': respostaSelecionada.enviado_por === 'tecnico' ? 'rgb(110, 108, 222)' : 'rgb(53, 178, 124)'}">{{respostaSelecionada.enviado_por_mensagem}}</span><br/>
                                        <div style="word-break: break-word; overflow-wrap: break-word;" [innerHtml]="respostaSelecionada.midia ? respostaSelecionada.midia : respostaSelecionada.body"></div>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="padding: 14px;">
                            <div class="col-12" *ngIf="chatSelecionado.status_id === 2 && conectado === true && !historico_chat; else infoMsgs">
                                <span>
                                    <i class="fas fa-microphone fa-lg icon-chat-opt" (click)="openMic(chatSelecionado)"
                                        *ngIf="chatSelecionado.status_id !== 3"></i>
                                </span>
                                <span
                                container=".modal" [ngbTooltip]="tooltipAttachment" tooltipClass="custom-anexo-tooltip-chat" placement="left"><i class="fas fa-paperclip fa-lg icon-chat-opt" (click)="clickAnexo()"
                                    *ngIf="chatSelecionado.status_id !== 3"></i></span>
                                <span *ngIf="chatSelecionado.whatsapp_oficial"><i class="fas fa-regular fa-message-lines fa-sm icon-chat-opt" (click)="abrirModalEnvioWhatsApp(false)"
                                        *ngIf="chatSelecionado.status_id === 2"></i></span>
                                <div class="text-left" [ngClass]="{'emoji-addon': chatSelecionado.whatsapp_oficial, 'emoji-addon-zapfy': !chatSelecionado.whatsapp_oficial}">
                                    <emoji-mart #emojiMart id="emoji-mart" class="emoji-selector" *ngIf="showEmoji" (emojiSelect)="addEmoji($event)" [showPreview]="false" [i18n]="traducaoEmoji" [autoFocus]="true"
                                        [style]="{ position: 'absolute', bottom: '36px', right: '20px' }">
                                    </emoji-mart>
                                    <span>
                                        <i #toggleEmojiMart style="margin-top: 23px;padding: 9px; cursor: pointer;"
                                            class="far fa-laugh fa-lg" *ngIf="chatSelecionado.status_id !== 3"
                                            (click)="showEmoji = !showEmoji"></i>
                                    </span>
                                </div>
                                <textarea #chatBox id="chatBoxWhatsApp" class="form-control mensagem_dados chat-text" [rows]="1" [maxRows]="10"
                                    placeholder="{{ 'INSIRA_MENSAGEM_AQUI' | translate }}"
                                    type="text" [(ngModel)]="mensagem" (keydown)="autoGrow($event, chatBox, scrollMe)" (keydown.enter)="onEnterKeyPress($event)"
                                    [disabled]="chatSelecionado.status_id === 3 || chatSelecionado.status_id === 1 || conectado === false || historico_chat || enviandoMsg"
                                    name="mensagem_dados" autocomplete="new-name"
                                    (paste)="verificaImagemOnPaste($event)"
                                    (click)="marcarLido(chatSelecionado)">
                                </textarea>
                                <input id="fileInput" style="display: none" type="file"
                                    (click)="$event.target.value=null" (change)="changeFile($event.target.files, chatSelecionado)" multiple>
                                <button type="button" class="btn btn-chat-enviar" [disabled]="!mensagem.length > 0 || enviandoMsg" (click)="enviarMsg(); autoGrow(null, chatBox, scrollMe, true)">
                                    <i class="mdi mdi-send"></i>
                                </button>
                            </div>
                            <ng-template #infoMsgs>
                                <div *ngIf="(apenas_historico || historico_chat) then historico; else acao">
                                </div>
                                <ng-template #historico>
                                    <div class="col-12 justify-content-center">
                                        <span *ngIf="chatSelecionado.status_id === 1">
                                            {{ chatSelecionado.status_situacao ? chatSelecionado.status_situacao : ('AGUARDANDO_ATENDIMENTO' | translate) }}
                                        </span>
                                        <span *ngIf="chatSelecionado.status_id === 2">
                                            {{ 'EM_ATENDIMENTO' | translate }}
                                        </span>
                                        <span *ngIf="chatSelecionado.status_id === 3">
                                            {{ chatSelecionado.status_situacao ? chatSelecionado.status_situacao : ('FINALIZADO' | translate) }}
                                        </span>
                                    </div>
                                </ng-template>
                                <ng-template #acao>
                                    <div class="col-12 justify-content-center">
                                        <span *ngIf="chatSelecionado.status_id === 1">
                                            {{ 'ATENDA_CHAMADO_ENVIAR_MSG' | translate }}
                                        </span>
                                        <span *ngIf="chatSelecionado.status_id === 3">
                                            {{ chatSelecionado.status_situacao ? chatSelecionado.status_situacao : ('FINALIZADO' | translate) }}
                                        </span>
                                        <span *ngIf="conectado === false && reconectando === true">
                                            {{ ('RECONECTANDO' | translate) + ' - ' + tentativas}}
                                        </span>
                                        <span *ngIf="conectado === false && !reconectando && !tooManyMsg">
                                            {{ 'DESCONECTADO' | translate }}
                                        </span>
                                        <span *ngIf="conectado === false && tooManyMsg">
                                            {{ ('DESCONECTADO' | translate) + '. ' + tooManyMsg}}
                                        </span>
                                    </div>
                                </ng-template>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="allowChatGPT && closeChatGPTModal" class="col-3 divider-top p-0">
                <div class="col-12 mt-3">
                    <div [formGroup]="createAnswerToChat">
                        <app-chat-gpt
                        id="chat-gpt-gerador-sugestao-comentario"
                        [chatGPTFormGroup]="createAnswerToChat"
                        [aiChat]="true"
                        chatGPTFormControlName="chatGPT"
                        formControlName="chatGPT"
                        class="flex-grow-1"
                        name="chatGPT"
                        (chatGPTButtonClicked)="generateChatGPT()"
                        ></app-chat-gpt>
                        <div *ngIf="chatGPTSuggestion" class="container-model-chatGPT-chat">
                            <div class="box-model-chatGPT-chat">
                                <div class="mx-3 my-3 model-chatGPT-chat" [innerHtml]="chatGPTSuggestion"></div>
                            </div>
                        </div>
                        <div *ngIf="chatGPTSuggestion" class="text-right mt-3 z-10">
                            <button container=".modal" [ngbTooltip]="translate.instant('COPIAR_TEXTO')" id="btn-copy-chat" type="button" class="btn btn-darkgray rounded-circle" (click)="copy()"
                            style="width: 60px; height: 60px">
                            <i class="fas fa-copy" style="font-size: 25px;"></i>
                            </button>
                        </div>
                    </div>
                  </div>
            </div>
        </div>
    </div>
    <ng-template #leituraHistorico>
        <div class="modal-body divider-top px-0" style="overflow: hidden; padding: 0 !important;">
            <div class="row w-100 ml-0">
                <div class="col-12 dark-back">
                    <!-- informacoes do chat -->
                    <div class="row line-data" style="margin-bottom: 10px; margin-top: 10px !important;">
                        <div *ngIf="chatSelecionado" class="d-flex col-6 mt-2">
                            <div>
                                <img alt="Image placeholder" [src]="chatSelecionado.avatar || 'assets/img/theme/user.png'"
                                    class="avatar rounded-circle mt-1 mr-3" style="max-width: 49px;" (click)="abrirInfoContato(chatSelecionado)" />
                            </div>
                            <div>
                                <div class="chat-name">
                                    {{chatSelecionado.contato?.descricao ? chatSelecionado.contato?.descricao : 
                                    chatSelecionado.numero_contato ? chatSelecionado.numero_contato : ''}} 
                                    {{chatSelecionado.cliente && chatSelecionado.cliente.text ? '- ' + chatSelecionado.cliente.text : null }}
                                </div>
                                <div class="chat-name">
                                    {{chatSelecionado.contato?.celular ?
                                    (chatSelecionado.contato?.celular | mask:'(00) 00000-0000 || (00) 0000-0000') : chatSelecionado.contato?.telefone 
                                    ? (chatSelecionado.contato?.telefone | mask:'(00) 0000-0000') : ''}}
                                    {{chatSelecionado.contato?.email ? '- ' + chatSelecionado.contato?.email : chatSelecionado.email ?
                                    '- ' + chatSelecionado.email : ''}}
                                </div>
                                <div class="chat-lastmsg" style="cursor: pointer;" *ngIf="chatSelecionado.chamado_vinculado"
                                    (click)="openTicket(chatSelecionado.chamado_vinculado)">
                                    <i style="margin-top: 5px;" *ngIf="chatSelecionado.chamado_vinculado"
                                        class="fas fa-ticket-alt fa-lg"></i> 
                                        {{ chatSelecionado.chamado_vinculado ? ' #'+chatSelecionado.chamado_vinculado.codigo : ''}}
                                </div>
                                <div class="chat-lastmsg">
                                    {{ 'ULTIMA_INTERACAO' | translate }} {{chatSelecionado.data_mensagem}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row dark-back w-100 ml-0" style="height: 585px;">
                <div class="col-12 darker-back divider-top p-0" style="max-height: 100%;">
                    <div id="chat-msgs">
                        <div #scrollMe id="msg-item" class="msg-item" style="bottom: 152px;" (scroll)="onScroll($event)">
                            <div #messages class="msg" *ngFor="let msg of mensagensChat; let i = index; let last = last">
                                <div [id]="'msg-'+i"
                                    [ngClass]="msg.enviado_por === 'robo' || msg.enviado_por === 'tecnico' ? 'text-right' : 'text-left'">

                                    <div container=".modal" [ngbTooltip]="msg.formatedBody.length > 50 ? msg.formatedBody : ''"
                                        [innerHtml]="msg.formatedBody"
                                        (click)="visualizarArquivo(msg, $event)"
                                        class="msg-origem msg-transferencia text-left"
                                        *ngIf="msg.is_transferencia && msg.formatedBody"
                                        style="white-space: pre-line; word-break: break-word;">
                                    </div>
                                    <div container=".modal" [ngbTooltip]="msg.autor ? msg.autor.nome : msg.user"
                                        [innerHtml]="msg.formatedBody"
                                        (click)="visualizarArquivo(msg, $event)"
                                        class="msg-origem text-left"
                                        *ngIf="(msg.enviado_por === 'robo' || msg.enviado_por === 'tecnico') && msg.formatedBody"
                                        style="white-space: pre-line; word-break: break-word;">
                                    </div>
                                    <div container=".modal" [ngbTooltip]="chatSelecionado?.contato?.descricao ? chatSelecionado?.contato?.descricao : 
                                    chatSelecionado?.numero_contato ? chatSelecionado?.numero_contato : msg.autor ? msg.autor.nome : msg.user"
                                        [innerHtml]="msg.formatedBody"
                                        class="msg-destino text-left" style="white-space: pre-line; word-break: break-word;"
                                        *ngIf="msg.enviado_por === 'cliente' && msg.formatedBody"></div>
                                    {{last ? scrollToBottom() : ''}}
                                </div>
                            </div>
                        </div>
                        <div class="darker-back input-box" *ngIf="chatSelecionado">
                            <div class="row" style="padding: 14px;">
                                <div class="col-12 justify-content-center">
                                    <ng-container *ngIf="historico_unificado; else footerHistoricoNormal">
                                        <span>
                                            {{ ('HISTORICO_CONVERSAS' | translate)}}
                                        </span>
                                    </ng-container>
                                    <ng-template #footerHistoricoNormal>
                                        <span *ngIf="chatSelecionado.status_id === 1">
                                            {{ chatSelecionado.status_situacao ? chatSelecionado.status_situacao : ('AGUARDANDO_ATENDIMENTO' | translate) }}
                                        </span>
                                        <span *ngIf="chatSelecionado.status_id === 2">
                                            {{ 'EM_ATENDIMENTO' | translate }}
                                        </span>
                                        <span *ngIf="chatSelecionado.status_id === 3">
                                            {{ chatSelecionado.status_situacao ? chatSelecionado.status_situacao : ('FINALIZADO' | translate) }}
                                        </span>
                                        <span *ngIf="conectado === false && !tooManyMsg">
                                            {{ 'DESCONECTADO' | translate }}
                                        </span>
                                        <span *ngIf="conectado === false && tooManyMsg">
                                            {{ ('DESCONECTADO' | translate)  + '. ' + tooManyMsg}}
                                        </span>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>

<ng-template #tooltipAttachment>
  <div class="d-grid">
    <span [translate]="'ANEXO_MAXIMO_ARQUIVOS'"></span>
    <span [translate]="'ANEXO_TAMANHO_ARQUIVO'"></span>
    <span [translate]="'ANEXO_ARQUIVOS_SUPORTADOS'"></span>
  </div>
</ng-template>

<ng-template #loadingChatsTemp>
    <div class="loading-cards-ticket chat-list w-100">
        <div class="chat-item card" style="border-radius: 7px;">
            <div class="row">
                <div class="col-md-2 text-center d-flex align-items-center justify-content-center"
                    style="border-right: 1px solid #D8D8D8;">
                    <span class="content" style="width: 25px; height: 25px; border-radius: 50px;">
                    </span>
                </div>
                <div class="col-md-8">
                    <div class="row">
                        <div class="col-md-2 d-flex align-items-center justify-content-center">
                            <span class="content" style="width: 35px; height: 35px; border-radius: 50px;">
                            </span>
                        </div>
                        <div class="col-md-10">
                            <div class="content" style="width: 120px; height: 18px; border-radius: 3px;"></div>
                            <div class="content mt-1" style="width: 150px; height: 18px; border-radius: 3px;"></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="fila-chat content" style="width: 100px; height: 27px;">
                    </div>
                    <div class="chat-time content" style="width: 25px; height: 14px;"></div>
                </div>
            </div>
        </div>
        <div class="chat-item card" style="border-radius: 7px;">
            <div class="row">
                <div class="col-md-2 text-center d-flex align-items-center justify-content-center"
                    style="border-right: 1px solid #D8D8D8;">
                    <span class="content" style="width: 25px; height: 25px; border-radius: 50px;">
                    </span>
                </div>
                <div class="col-md-8">
                    <div class="row">
                        <div class="col-md-2 d-flex align-items-center justify-content-center">
                            <span class="content" style="width: 35px; height: 35px; border-radius: 50px;">
                            </span>
                        </div>
                        <div class="col-md-10">
                            <div class="content" style="width: 120px; height: 18px; border-radius: 3px;"></div>
                            <div class="content mt-1" style="width: 150px; height: 18px; border-radius: 3px;"></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="fila-chat content" style="width: 100px; height: 27px;">
                    </div>
                    <div class="chat-time content" style="width: 25px; height: 14px;"></div>
                </div>
            </div>
        </div>
        <div class="chat-item card" style="border-radius: 7px;">
            <div class="row">
                <div class="col-md-2 text-center d-flex align-items-center justify-content-center"
                    style="border-right: 1px solid #D8D8D8;">
                    <span class="content" style="width: 25px; height: 25px; border-radius: 50px;">
                    </span>
                </div>
                <div class="col-md-8">
                    <div class="row">
                        <div class="col-md-2 d-flex align-items-center justify-content-center">
                            <span class="content" style="width: 35px; height: 35px; border-radius: 50px;">
                            </span>
                        </div>
                        <div class="col-md-10">
                            <div class="content" style="width: 120px; height: 18px; border-radius: 3px;"></div>
                            <div class="content mt-1" style="width: 150px; height: 18px; border-radius: 3px;"></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="fila-chat content" style="width: 100px; height: 27px;">
                    </div>
                    <div class="chat-time content" style="width: 25px; height: 14px;"></div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #semChatsNaLista>
    <div style="margin-top: 7vh;">
        <div class="row">
          <div class="col-12 d-flex justify-content-center">
            <div>
              <i class="fa-light fa-circle-xmark" style="font-size: 80px;"></i>
            </div>
            <div style="margin-left: -26px; padding-top: 40px;">
              <i class="fa-light fa-magnifying-glass" style="font-size: 60px;"></i>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12 text-center">
            <span 
              style="font-size: 24px; font-weight: bold; display: inline-block;" 
              [translate]="'SEM_CHATS_STATUS'">
            </span>
          </div>
        </div>
    </div>
</ng-template>

<ng-template #loadingChatsScrollTemp>
    <div class="row mt-3">
        <div class="col-12 d-flex align-items-center justify-content-center">
            <div>
                <div class="jelly-triangle">
                    <div class="jelly-triangle__dot"></div>
                    <div class="jelly-triangle__traveler"></div>
                </div>
                
                <svg width="0" height="0" class="jelly-maker">
                    <defs>
                        <filter id="uib-jelly-triangle-ooze">
                            <feGaussianBlur in="SourceGraphic" stdDeviation="7.3" result="blur"></feGaussianBlur>
                            <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" result="ooze"></feColorMatrix>
                            <feBlend in="SourceGraphic" in2="ooze"></feBlend>
                        </filter>
                    </defs>
                </svg>
            </div>
            <span class="font-16 ml-3" [translate]="'CARREGANDO_CHATS_AGUARDE'"></span>
        </div>
    </div>
</ng-template>